import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { HighChartDonutChart } from '../../../shared';
import { useSelector } from 'react-redux';
import { AGE_ENGAGEMENT_CHART_OPTIONS } from './contants';

const STATIC_DATA = [
    { name: '20-45', y: 5 },
    { name: '45-70', y: 83 },
    { name: '70+', y: 12 }
];

const AgeEngagement = () => {
    const { company } = useSelector((state) => state.company);
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, ageEngagementData } = dtcData;
    const chartData = company.id === 61 ? STATIC_DATA : ageEngagementData;

    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Typography className="text-md-medium gray-900">
                Engagement Breakdown By Age
            </Typography>
            {isWebMatrixPatientLoading ? (
                <Skeleton height={400} variant="rectangular" width="100%" />
            ) : (
                <HighChartDonutChart
                    chartOptions={AGE_ENGAGEMENT_CHART_OPTIONS}
                    seriesData={chartData}
                />
            )}
        </Box>
    );
};

export default AgeEngagement;
